import { useQuery } from 'react-query';
import { fetchAnalyticsData } from '../../../api/analytics.ts';
import { AnalyticsData } from '../../../types/analytics.ts';

export const useDashboardData = () => {
  const {
    data: analyticsData,
    isLoading,
    error,
  } = useQuery<AnalyticsData>('dashboardData', fetchAnalyticsData);

  return {
    metrics: analyticsData?.performanceMetrics,
    strategies: analyticsData?.strategies,
    lastAnalysisDate: analyticsData?.lastAnalysisDate,
    nextUpdateScheduled: analyticsData?.nextUpdateScheduled,
    modelAccuracy: analyticsData?.modelAccuracy,
    isLoading,
    error,
  };
}; 